import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {LoadingSpinner} from '../loadingSpinner/LoadingSpinner'
import { useIntl } from 'react-intl';
import { callApi } from "../auth/ApiService";
import common from "../config/common.json";
import styles from "./ChildConfirmOtp.css";


function ConfirmOtp() {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const { newPassword, newEmail,firstname} = state;
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [timerOn, setTimerOn] = useState(false);
  const [remainingSecond, setRemainingSecond] = useState('30');
  const [isLoading, setIsLoading] = useState(false);
  const [hide, setHide] = useState(false);
  const intl = useIntl();
  function confirmOTP(e) {
    if (otp !== "") {
      e.preventDefault();
      setIsLoading(false);
      userCondirmOTP();
    }
  }
  
  async function asignUser() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: newEmail,
      password: newPassword,
      plan: "Freelancer",
      firstname: firstname
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      await callApi(`${common.serverless_api_dev}assignPlan`,requestOptions);
    } catch (error) {
      console.log(error);
    }
  }

  async function userCondirmOTP() {
    if(isLoading){
      return 0;
    }
    var password = newPassword;
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: newEmail,
      code: otp,
    });
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };


      try {
        const result = await callApi(`${common.serverless_api_dev}confirmRegistration`,requestOptions);
        var msg = JSON.parse(result.body);
        var email = newEmail;
        if (msg.success === false) {
          setIsLoading(false);
          setError(msg.msg);
        } else if (msg.success === true) {
          setIsLoading(false);
          asignUser(email, password);
          setSuccess(intl.formatMessage({ id: 'userRegisterSuccessMsg' }))
          setTimeout(()=>{
            navigate("/");
          },3000)
        }
      } catch (error) {
        console.log(error);
      }
  }

  async function resendConfirmationCode() {
    if (timerOn){
      return 0;
    }
    setHide(false);
    setError("");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: newEmail,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };


    try {
      await callApi(`${common.serverless_api_dev}resendConfirmationCode`,requestOptions);
      setTimerOn(true);
      timer(30);
    } catch (error) {
      console.log(error);
      setHide(true);
    }
  }

  function timer(remaining) {
    var isTimerOn = true;
    var s = remaining % 60;
    
    s = s < 10 ? '0' + s : s;
    setRemainingSecond(s)
    remaining -= 1;

    if(remaining >= 0 && isTimerOn) {
      setTimeout(function() {
          timer(remaining);
      }, 1000);
      return;
    }
  
    if(!isTimerOn) {
      return;
    }
    
    isTimerOn = false;
    setTimerOn(false);
  }

  return (
    <div className={("confirm_otp_wrapper responsive_wrapper")}>
      <img src={`/assets/image/${common.ClientId}_logo.png`} className={("second_logo")} />      
    <div>
    
      {hide === true ? (
        " "
      ) : (
        <div className={("light confirm_box confirm_otp_size")} id="errorOtp">
        {intl.formatMessage({ id: 'ConfirmationCodeIsSentSuccessfullyText' })}
        </div>
      )}
      <div className={("error")}>{error}</div>
      <div className={("success_msg ")}>{success}</div>
      <form>
        <label>
          <p className={("font_main_color label_login otp_label")}>{intl.formatMessage({ id: 'otpChildConfirmLabel' })}</p>
          <input
            autoFocus
            className={("input_edit confirm_otp_size")}
            type="text"
            placeholder="Enter OTP"
            maxLength="6"
            onChange={(e) => {
              setOtp(e.target.value);
              setHide(true);
              setError("")
            }}
            required
          />
        </label>
        <div>
          <button
            className={("btn_main_child_confirm_otp btn_sign_in_confirm_otp")}
            type="submit"
            onClick={confirmOTP}
          >
            {isLoading? <LoadingSpinner className={("small")} varient="white" position="center" /> : "Confirm" }
          </button>
        </div>
      </form>
      <a className={("font_main_color forget resend")} onClick={resendConfirmationCode}>
        { timerOn ? `Resend OTP in: ${remainingSecond} seconds` : "Resend OTP" }
      </a>
      </div>
    </div>
  );
}

export default ConfirmOtp;
